import React, { useMemo } from 'react';
import clsx from 'clsx';
import { ImageList, ImageListItem, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';

import MediaCard from './media-card/MediaCard';
import EmptyGallery from './empty-gallery/EmptyGallery';
import CommonLoader from '../../components/common-loader/CommonLoader';

import scss from './MediaGallery.module.scss';

function MediaGallery({ className, style, actionOptions = [], additionalCardActions = [] }) {
  const isMobile = useMediaQuery('(max-width: 768px)');

  const mediaGallery = useSelector((state) => state.aiStudio.responses);
  const isResponsesLoading = useSelector((state) => state.aiStudio.isResponsesLoading);

  const colsCount = useMemo(() => {
    if (isMobile) return 1;
    return 2;
  }, [isMobile]);

  return (
    <div className={clsx(className, scss.wrapper)} style={style}>
      {mediaGallery.length ? (
        <ImageList variant='masonry' cols={colsCount} gap={8}>
          {mediaGallery.map((item) => (
            <ImageListItem key={item.id}>
              <MediaCard
                id={item.id}
                requestId={item.requestId}
                media={item.previewUrl}
                mediaType={item.mediaType}
                actionType={item.actionType}
                time={item.time}
                fileName={item.fileName}
                favoriteId={item.favoriteId}
                isSaved={item.isSaved}
                isFavorite={item.isFavorite}
                actionOptions={actionOptions}
                additionalCardActions={additionalCardActions}
              />
            </ImageListItem>
          ))}
        </ImageList>
      ) : (
        <EmptyGallery />
      )}

      <CommonLoader isLoading={isResponsesLoading} />
    </div>
  );
}

export default MediaGallery;
